import type { LoginIdentityResult, SuspensionInfo } from '../hooks/useIdentity.types';

export interface LoginFailureResolution {
  result: LoginIdentityResult;
  suspensionInfo?: SuspensionInfo;
}

function parseRetryAfterSeconds(raw?: string): number | undefined {
  if (raw == null || raw === '') return undefined;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? Math.floor(n) : undefined;
}

export function resolveLoginFailure(
  errorMessage: string,
  serverCode?: string,
  details?: {
    moderationReason?: string;
    moderationReportId?: string;
    suspendedUntil?: string;
    retryAfter?: string;
    attemptNumber?: number;
  }
): LoginFailureResolution {
  const retryAfter = parseRetryAfterSeconds(details?.retryAfter);
  const attemptNumber =
    typeof details?.attemptNumber === 'number' ? details.attemptNumber : undefined;

  if (serverCode === 'ALIAS_SUSPENDED' || serverCode === 'ALIAS_BANNED') {
    const info: SuspensionInfo = {
      type: serverCode === 'ALIAS_BANNED' ? 'banned' : 'suspended',
      reason: details?.moderationReason,
      reportId: details?.moderationReportId,
      suspendedUntil: details?.suspendedUntil,
    };
    return {
      suspensionInfo: info,
      result: {
        success: false,
        error: errorMessage,
        errorCode: serverCode,
        suspensionInfo: info,
      },
    };
  }

  let errorCode: LoginIdentityResult['errorCode'] = 'INVALID_PASSPHRASE';
  if (serverCode === 'LOCKED_OUT' || errorMessage.includes('locked')) {
    errorCode = 'LOCKED_OUT';
  } else if (serverCode === 'RATE_LIMITED' || errorMessage.includes('wait')) {
    errorCode = 'RATE_LIMITED';
  } else if (
    serverCode === 'GEOFENCE_BLOCKED' ||
    serverCode === 'AGE_VERIFICATION_REQUIRED' ||
    serverCode === 'AGE_VERIFICATION_FAILED' ||
    serverCode === 'AGE_VERIFICATION_COOLDOWN'
  ) {
    errorCode = serverCode;
  }
  return {
    result: {
      success: false,
      error: errorMessage,
      errorCode,
      retryAfter,
      attemptNumber,
    },
  };
}

